export const openExternalLink = (link: string) => {
  if (window.nativeApi) {
    window.nativeApi.openExternalBrowser(link);
    return;
  }
  window.open(link, '_blank');
};
